import * as Yup from "yup";
import dayjs from "dayjs"

export const initialValues = {
  endorseMentDate: dayjs(),
  startTime: "00:00:00",
  endTime: "00:00:00",
  description: null,
};

const RedeemTimeSchema = Yup.object().shape({
  endorseMentDate: Yup.string().required("Please select."),
  description: Yup.string().required("Please enter."),
});

export default RedeemTimeSchema;
